import {connect} from 'react-redux';
import {FileItem} from './FileItem';
import {getStepData} from '../../../../../modules/Inspection/actions/steps/getStepData';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getFileList} from '../../../../../modules/Inspection/actions/files/getFileList';

const mapStateToProps = ({
                           stepData: {stepData}
                         }) => ({
  stepData
});

export default connect(
  mapStateToProps,
  {
    getStepData,
    showGlobalErrorMessage,
    getFileList
  }
)(FileItem);
